import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from "../../../config";

const AddBankAccount = () => {
  const [formData, setFormData] = useState({
    bankName: '',
    accountName: '',
    accountNumber: '',
    ifscCode: '',
    accountCapital: ''
  });
  const [bankAccounts, setBankAccounts] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchBankAccounts = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_URL}/api/bank-account`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.success) {
        setBankAccounts(response.data.accounts);
      }
    } catch (error) {
      console.error('Error fetching bank accounts:', error);
    }
  };

  useEffect(() => {
    fetchBankAccounts();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (editingId) {
        const res = await axios.put(`${API_URL}/api/bank-account/${editingId}`, formData, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.success) {
          alert(res.data.message);
          setEditingId(null);
          setFormData({
            bankName: '',
            accountName: '',
            accountNumber: '',
            ifscCode: '',
            accountCapital: ''
          });
          fetchBankAccounts();
        } else {
          alert(res.data.message);
        }
      } else {
        const res = await axios.post(`${API_URL}/api/bank-account`, formData, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.success) {
          alert(res.data.message);
          setFormData({
            bankName: '',
            accountName: '',
            accountNumber: '',
            ifscCode: '',
            accountCapital: ''
          });
          fetchBankAccounts();
        } else {
          alert(res.data.message);
        }
      }
    } catch (error) {
      alert(error.response?.data?.message || 'Error processing request');
    }
    setLoading(false);
  };

  const handleEdit = (account) => {
    setEditingId(account._id);
    setFormData({
      bankName: account.bankName,
      accountName: account.accountName,
      accountNumber: account.accountNumber,
      ifscCode: account.ifscCode,
      accountCapital: account.accountCapital
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this bank account?")) {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.delete(`${API_URL}/api/bank-account/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.success) {
          alert(res.data.message);
          fetchBankAccounts();
        }
      } catch (error) {
        alert('Error deleting bank account');
      }
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ marginBottom: '20px' }}>Add Bank Account</h2>
      
      <div style={{ background: '#fff', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', marginBottom: '30px' }}>
        <form onSubmit={handleSubmit} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Bank Name</label>
            <input 
              type="text" 
              name="bankName" 
              value={formData.bankName} 
              onChange={handleChange} 
              required 
              style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Account Holder Name</label>
            <input 
              type="text" 
              name="accountName" 
              value={formData.accountName} 
              onChange={handleChange} 
              required 
              style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Account Number</label>
            <input 
              type="text" 
              name="accountNumber" 
              value={formData.accountNumber} 
              onChange={handleChange} 
              required 
              style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>IFSC Code</label>
            <input 
              type="text" 
              name="ifscCode" 
              value={formData.ifscCode} 
              onChange={handleChange} 
              required 
              style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Account Capital (Current Balance)</label>
            <input 
              type="number" 
              name="accountCapital" 
              value={formData.accountCapital} 
              onChange={handleChange} 
              required 
              style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
            />
          </div>

          <div style={{ gridColumn: 'span 2', textAlign: 'right' }}>
            <button 
              type="submit" 
              disabled={loading}
              style={{ 
                padding: '10px 20px', 
                backgroundColor: '#003e6d', 
                color: '#fff', 
                border: 'none', 
                borderRadius: '4px', 
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              {loading ? (editingId ? 'Updating...' : 'Adding...') : (editingId ? 'Update Bank Account' : 'Add Bank Account')}
            </button>
            {editingId && (
              <button 
                type="button" 
                onClick={() => {
                  setEditingId(null);
                  setFormData({ bankName: '', accountName: '', accountNumber: '', ifscCode: '', accountCapital: '' });
                }}
                style={{ 
                  padding: '10px 20px', 
                  backgroundColor: '#6c757d', 
                  color: '#fff', 
                  border: 'none', 
                  borderRadius: '4px', 
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  marginLeft: '10px'
                }}
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>

      <h3 style={{ marginBottom: '20px' }}>Bank Accounts List</h3>
      <div style={{ overflowX: 'auto', background: '#fff', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
          <thead>
            <tr style={{ backgroundColor: '#f3f4f6', borderBottom: '2px solid #ddd' }}>
              <th style={{ padding: '12px' }}>Bank Name</th>
              <th style={{ padding: '12px' }}>Account Holder Name</th>
              <th style={{ padding: '12px' }}>Account Number</th>
              <th style={{ padding: '12px' }}>IFSC Code</th>
              <th style={{ padding: '12px' }}>Account Capital</th>
              <th style={{ padding: '12px' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {bankAccounts.length > 0 ? (
              bankAccounts.map(account => (
                <tr key={account._id} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '12px' }}>{account.bankName}</td>
                  <td style={{ padding: '12px' }}>{account.accountName}</td>
                  <td style={{ padding: '12px' }}>{account.accountNumber}</td>
                  <td style={{ padding: '12px' }}>{account.ifscCode}</td>
                  <td style={{ padding: '12px' }}>₹{account.accountCapital}</td>
                  <td style={{ padding: '12px' }}>
                    <button 
                      onClick={() => handleEdit(account)} 
                      style={{ 
                        background: '#ffc107', 
                        color: 'black', 
                        border: 'none', 
                        padding: '6px 12px', 
                        borderRadius: '4px', 
                        cursor: 'pointer',
                        marginRight: '8px'
                      }}>
                      Edit
                    </button>
                    <button 
                      onClick={() => handleDelete(account._id)} 
                      style={{ 
                        background: '#dc3545', 
                        color: 'white', 
                        border: 'none', 
                        padding: '6px 12px', 
                        borderRadius: '4px', 
                        cursor: 'pointer' 
                      }}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ padding: '20px', textAlign: 'center' }}>No Bank Accounts Added Yet</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AddBankAccount;
